import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

import { CoreHttpService } from '@core/services/core-http.service';
import { UserService } from '@core/services/user.service';

import { CurrentUser } from '@core/models/current-user';
import { LiveSession } from '@core/models/live-session';
import { CommonModule } from '@angular/common';
import { MenuComponent } from '../menu/menu.component';
import { MobileMenuComponent } from '../mobile-menu/mobile-menu.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AccountProfileComponent } from '../account-profile/account-profile.component';

@Component({
	selector: 'kwo-community-header',
	templateUrl: './community-header.component.html',
	styleUrls: ['./community-header.component.scss'],
	host: { 'class': '' },
	standalone: true,
	imports: [CommonModule, RouterModule, MenuComponent, MobileMenuComponent, NgbDropdownModule, FaIconComponent, AccountProfileComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommunityHeaderComponent implements OnInit, OnDestroy {

	showMobileMenu: boolean = false;
	dropdownContainer: 'body' | null = null;

	private routeSubscription: Subscription;

	user: CurrentUser | null = null;
	liveStreams$: Observable<LiveSession[]>;

	constructor(private router: Router,
		private responsive: BreakpointObserver,
		private coreHttpService: CoreHttpService,
		public userService: UserService
	) {

		this.routeSubscription = router.events.subscribe((event) => {

			if (event instanceof NavigationStart) {

				this.showMobileMenu = false;
			}
		});
	}

	ngOnInit() {

		this.responsive.observe([Breakpoints.XSmall])
			.subscribe(result => {

				this.dropdownContainer = null;

				if (result.matches) {

					this.dropdownContainer = 'body';
				}
			});

		this.user = this.userService.getUser();
		this.liveStreams$ = this.coreHttpService.getLiveSessions();
	}

	toggleMobile() {

		this.showMobileMenu = !this.showMobileMenu;
	}

	goToHome() {

		this.router.navigate(['/']);
	}

	goToLivestream(link: string) {

		window.open(link, '_blank', 'noopener, noreferrer');
	}

	ngOnDestroy(): void {

		if (this.routeSubscription) {

			this.routeSubscription.unsubscribe();
		}
	}
}
